module.exports = __webpack_public_path__ + "static/media/centre-appel.e90d3e5f.png";